import React from 'react';
import Card from '../../ui/Card';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, ResponsiveContainer, Tooltip } from 'recharts';
const PerformanceVsTargetsRadar: React.FC = () => {
  const data = [{
    metric: 'Revenue Growth',
    actual: 105.2,
    target: 100,
    fullMark: 120
  }, {
    metric: 'EBITDA Margin',
    actual: 104.6,
    target: 100,
    fullMark: 120
  }, {
    metric: 'OEE',
    actual: 97.1,
    target: 100,
    fullMark: 120
  }, {
    metric: 'Quality Score',
    actual: 94.2,
    target: 100,
    fullMark: 120
  }, {
    metric: 'Customer Satisfaction',
    actual: 92.5,
    target: 100,
    fullMark: 120
  }, {
    metric: 'Working Capital',
    actual: 102.2,
    target: 100,
    fullMark: 120
  }, {
    metric: 'Safety Score',
    actual: 96.8,
    target: 100,
    fullMark: 120
  }, {
    metric: 'Innovation Index',
    actual: 88.5,
    target: 100,
    fullMark: 120
  }];
  return <Card className="p-6 bg-gradient-to-br from-purple-50 to-white" data-id="element-3033">
      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-3034">
        Performance vs Targets Radar
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-3035">
        Multi-dimensional performance analysis (% of target)
      </p>
      <ResponsiveContainer width="100%" height={400} data-id="element-3036">
        <RadarChart data={data} data-id="element-3037">
          <PolarGrid stroke="#e5e7eb" data-id="element-3038" />
          <PolarAngleAxis dataKey="metric" tick={{
          fontSize: 11,
          fill: '#374151'
        }} data-id="element-3039" />
          <PolarRadiusAxis angle={90} domain={[0, 120]} tick={{
          fontSize: 10
        }} data-id="element-3040" />
          <Radar name="Actual Performance" dataKey="actual" stroke="#8b5cf6" fill="#8b5cf6" fillOpacity={0.6} strokeWidth={2} data-id="element-3041" />
          <Radar name="Target" dataKey="target" stroke="#10b981" fill="#10b981" fillOpacity={0.3} strokeWidth={2} strokeDasharray="5 5" data-id="element-3042" />
          <Legend data-id="element-3043" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => `${value.toFixed(1)}%`} data-id="element-3044" />
        </RadarChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-3045">
        <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-3046">
          <div className="text-center" data-id="element-3047">
            <div className="text-gray-600" data-id="element-3048">Metrics Above Target</div>
            <div className="text-xl font-bold text-green-600" data-id="element-3049">4/8</div>
          </div>
          <div className="text-center" data-id="element-3050">
            <div className="text-gray-600" data-id="element-3051">Avg Achievement</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-3052">97.6%</div>
          </div>
          <div className="text-center" data-id="element-3053">
            <div className="text-gray-600" data-id="element-3054">Best Performance</div>
            <div className="text-xl font-bold text-green-600" data-id="element-3055">Revenue</div>
          </div>
          <div className="text-center" data-id="element-3056">
            <div className="text-gray-600" data-id="element-3057">Focus Area</div>
            <div className="text-xl font-bold text-orange-600" data-id="element-3058">Innovation</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default PerformanceVsTargetsRadar;